var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("fieldset", [
        _c("legend", [
          _vm._v(
            "\n      " + _vm._s(_vm.t("app-3-national-standards")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "national-standards-body description",
            domProps: {
              innerHTML: _vm._s(_vm.t("app-3-national-standards-body")),
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.t("app-3-national-standards-body")) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("background-checks", { attrs: { program: _vm.program } }),
      _vm._v(" "),
      _c("training", { attrs: { program: _vm.program } }),
      _vm._v(" "),
      _c("minimum", { attrs: { program: _vm.program } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }